/* Páginas legales (políticas de Shopify y páginas de contenido): índice lateral + chip de actualización */
(() => {
  const policy = document.querySelector('.shopify-policy__container');
  const pageRoot = document.querySelector('main .container--narrow.rte');
  const root = policy || pageRoot;
  if (!root || root.dataset.legalReady) return;
  root.dataset.legalReady = '1';
  root.classList.add('legal');

  const titleEl = policy ? policy.querySelector('.shopify-policy__title') : root.querySelector(':scope > h1');
  if (!titleEl) return;

  // Cuerpo del documento
  let article;
  if (policy) {
    article = policy.querySelector('.shopify-policy__body');
  } else {
    article = document.createElement('div');
    article.className = 'legal__article-wrap';
    [...root.childNodes].forEach((n) => { if (n !== titleEl) article.appendChild(n); });
    root.appendChild(article);
  }
  article.classList.add('legal__article');
  const rte = article.querySelector('.rte') || article;

  // Cabecera: título + chip "Última actualización"
  const head = document.createElement('header');
  head.className = 'legal__head';
  titleEl.parentNode.insertBefore(head, titleEl);
  head.appendChild(titleEl);
  titleEl.classList.add('legal__title');
  const first = rte.querySelector('p');
  if (first && /^\s*(Última|Ultima)\s+actualizaci/i.test(first.textContent)) {
    const chip = document.createElement('p');
    chip.className = 'legal__updated';
    chip.textContent = first.textContent.trim();
    head.appendChild(chip);
    first.remove();
  }

  // Índice a partir de los h2
  const slug = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const heads = [...rte.querySelectorAll('h2')];
  const used = new Set();
  heads.forEach((h) => {
    let id = h.id || slug(h.textContent) || 'seccion';
    while (used.has(id)) id += '-2';
    used.add(id);
    h.id = id;
  });

  const layout = document.createElement('div');
  layout.className = 'legal__layout';
  article.parentNode.insertBefore(layout, article);

  if (heads.length >= 3) {
    const toc = document.createElement('nav');
    toc.className = 'legal__toc';
    toc.setAttribute('aria-label', 'En esta página');
    toc.innerHTML = '<details class="legal__toc-box" open><summary class="legal__toc-title">En esta página</summary><ol class="legal__toc-list"></ol></details>';
    const list = toc.querySelector('ol');
    heads.forEach((h) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    layout.appendChild(toc);
    // En móvil el índice empieza cerrado
    if (window.matchMedia('(max-width: 1023px)').matches) toc.querySelector('details').removeAttribute('open');

    // Sección activa
    const links = new Map([...list.querySelectorAll('a')].map((a) => [a.hash.slice(1), a]));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            links.forEach((a) => a.classList.remove('is-active'));
            links.get(e.target.id)?.classList.add('is-active');
          }
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      heads.forEach((h) => io.observe(h));
    }
  } else {
    layout.classList.add('legal__layout--single');
  }
  layout.appendChild(article);
})();
